import React, { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import proof from "../assets/images/banner1.png";
import { FaBalanceScale, FaLock, FaShieldAlt } from "react-icons/fa";
import proofImg from "../assets/images/proof1.png";
import hash from "../assets/images/hash1.png";

const ProofOfReserves = () => {
  const [audit, setAudit] = useState(
    "01/05/25 00:00:00 UTC | BTC Block Height 894668"
  );

  const audits = [
    "01/05/25 00:00:00 UTC | BTC Block Height 894668",
    "01/04/25 00:00:00 UTC | BTC Block Height 890324",
    "01/03/25 00:00:00 UTC | BTC Block Height 889999",
  ];

  const coins = [
    {
      name: "BTC",
      ratio: "102.06%",
      customer: "604,410.571",
      reported: "616,886.378",
      exchange: "603,374.177",
      thirdParty: "13,512.201",
      icon: "₿",
      color: "bg-orange-500",
    },
    {
      name: "USDT",
      ratio: "102.07%",
      customer: "29,059,304,576.504",
      reported: "29,659,698,073.374",
      exchange: "29,197,284,979.619",
      thirdParty: "462,413,093.755",
      icon: "Ⓣ",
      color: "bg-green-500",
    },
    {
      name: "ETH",
      ratio: "100.16%",
      customer: "5,281,746.179",
      reported: "5,289,954.708",
      exchange: "5,153,559.383",
      thirdParty: "136,395.325",
      icon: "Ξ",
      color: "bg-purple-500",
    },
    {
      name: "BNB",
      ratio: "112.45%",
      customer: "39,244,784.615",
      reported: "44,130,417.299",
      exchange: "44,096,220.409",
      thirdParty: "34,196.89",
      icon: "◎",
      color: "bg-yellow-500",
    },
  ];

  return (
    <div className="bg-white text-gray-900 dark:bg-gray-900 dark:text-white min-h-screen transition-colors duration-300">
      <Header />

      {/* Hero Section */}
      <div
        className="max-w-6xl mx-auto py-16 px-4"
        style={{ backgroundImage: `url(${proof})` }}
      >
        <h1 className="text-5xl font-bold">Proof of Reserves</h1>
        <p className="mt-4 text-lg">
          Sample figures illustrate how an exchange may report asset coverage. This is not an audited Tillionx reserve report.
        </p>
        <button className="mt-8 px-6 py-3 bg-yellow-400 hover:bg-yellow-500 text-black font-medium rounded">
          View Report
        </button>
      </div>

      {/* Audit Section */}
      <div className="max-w-6xl mx-auto px-4">
        <div className="flex flex-col gap-4">
          <div className="flex items-center gap-4">
            <h4 className="font-semibold">Audit Time:</h4>
            <select
              value={audit}
              onChange={(e) => setAudit(e.target.value)}
              className="border border-gray-300 rounded px-3 py-2 w-full max-w-md"
            >
              {audits.map((a, i) => (
                <option key={i} value={a}>
                  {a}
                </option>
              ))}
            </select>
          </div>

          <div className="flex flex-col md:flex-row md:items-center gap-2">
            <h4 className="font-semibold">Verification Mechanism:</h4>
            <p className="text-gray-700 dark:text-gray-300">zk-SNARKs</p>
          </div>

          <div className="flex flex-col md:flex-row md:items-center gap-2">
            <h4 className="font-semibold">Merkle Root Hash:</h4>
            <p className="text-gray-700 dark:text-gray-300 break-all">
              2ec46cca001b03110fc79fcf51d1802b1c8501fe686112d7a5de74b0dd8bc24
            </p>
          </div>
        </div>

        {/* Buttons */}
        <div className="flex flex-wrap gap-4 mt-6">
          <button className="px-6 py-2 bg-yellow-400 hover:bg-yellow-500 text-black font-medium rounded">
            Download All Address ↓
          </button>
          <button className="px-6 py-2 border border-yellow-400 text-yellow-600 hover:bg-yellow-50 font-medium rounded">
            Learn More
          </button>
        </div>
      </div>

      {/* Ratio Cards */}
      <div className="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-12 px-4 pb-16">
        {coins.map((coin, i) => (
          <div
            key={i}
            className="p-6 bg-white dark:bg-gray-800 rounded-2xl shadow border border-gray-200 dark:border-gray-700"
          >
            <div className="flex items-center justify-between mb-4">
              <h3 className="font-semibold">{coin.name} Ratio</h3>
              <div
                className={`w-10 h-10 flex items-center justify-center rounded-full text-white ${coin.color}`}
              >
                {coin.icon}
              </div>
            </div>
            <p className="text-2xl font-bold">{coin.ratio}</p>

            <div className="mt-4 text-sm">
              <p className="text-gray-500">Customer Net Balances</p>
              <p className="font-medium">{coin.customer}</p>
            </div>
            <div className="mt-2 text-sm">
              <p className="text-gray-500">Reported Net Balances</p>
              <p className="font-medium">{coin.reported}</p>
            </div>
            <ul className="mt-3 text-sm text-gray-600 dark:text-gray-300 list-none pl-0">
              <li className="flex justify-between text-xs">
                Exchange Balance{" "}
                <span className="font-medium">{coin.exchange}</span>
              </li>
              <li className="flex justify-between text-xs">
                Third-Party Custody{" "}
                <span className="font-medium">{coin.thirdParty}</span>
              </li>
            </ul>
          </div>
        ))}
      </div>
      <div className="max-w-6xl mx-auto px-4">
        {/* Top Section */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
          {/* Left Content */}
          <div>
            <h2 className="text-3xl font-bold mb-4">
              What is Proof of Reserves (PoR)?
            </h2>
            <p className="text-gray-700 dark:text-gray-300 mb-4">
              When we say Proof of Reserves, we are specifically referring to
              those assets that we hold in custody for users. This means that we
              are a way to show evidence that an exchange holds assets to cover
              user balances 1:1, as well as any additional reserves.
            </p>
            <p className="text-gray-700 dark:text-gray-300 mb-4">
              When a user deposits one Bitcoin, an exchange&apos;s reserves
              should increase by at least one Bitcoin to ensure client funds are
              fully backed. Corporate holdings are typically tracked separately.
            </p>
            <p className="text-gray-700 dark:text-gray-300 mb-4">
              A reserve report can show whether user assets are backed 1:1 and
              may also disclose other reserves, liabilities, and emergency
              protection funds.
            </p>
            <p className="text-gray-700 dark:text-gray-300">
              Read on to see more information on what we have built to allow
              people to review reserve information published by their exchange.
            </p>
          </div>

          {/* Right Image */}
          <div className="flex justify-center">
            <img
              src={proofImg}
              alt="Proof of Reserves"
              className="max-w-sm w-full"
            />
          </div>    
        </div>

        <div className="my-16 bg-gray-50 dark:bg-gray-800 rounded-xl shadow p-8 text-center">
          <h3 className="text-xl font-semibold mb-8">
            Our commitment to our community remains the same as it has always
            been
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="flex flex-col items-center">
              <FaBalanceScale className="text-yellow-500 text-4xl mb-3" />
              <h4 className="font-semibold">Transparency</h4>
              <p className="text-gray-600 dark:text-gray-300 text-sm mt-2">
                We will always be transparent with our users
              </p>
            </div>

            <div className="flex flex-col items-center">
              <FaShieldAlt className="text-yellow-500 text-4xl mb-3" />
              <h4 className="font-semibold">Safety</h4>
              <p className="text-gray-600 dark:text-gray-300 text-sm mt-2">
                The safety of our users funds is a priority for us
              </p>
            </div>
  
            <div className="flex flex-col items-center">
              <FaLock className="text-yellow-500 text-4xl mb-3" />
              <h4 className="font-semibold">Protected</h4>
              <p className="text-gray-600 dark:text-gray-300 text-sm mt-2">
                Your funds are protected
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-white dark:bg-gray-900 dark:text-white py-16">
        <div className="max-w-6xl mx-auto px-4">
          {/* Section Title */}
          <h2 className="text-3xl font-bold mb-8">Merkle Tree</h2>

          {/* Subsection 1 */}
          <div className="mb-8">
            <h3 className="text-xl font-semibold mb-2">
              ▪ What have we built?
            </h3>
            <p className="text-gray-700 dark:text-gray-300">
              An exchange can use a Merkle tree (shown below) to let people
              verify their assets within a platform. Users can check their
              holdings using a generated Merkle hash or record ID and compare
              the result with an independent audit.
            </p>
          </div>

          {/* Subsection 2 */}
          <div className="mb-8">
            <h3 className="text-xl font-semibold mb-2">
              ▪ What is a Merkle Tree?
            </h3>
            <p className="text-gray-700 dark:text-gray-300">
              A Merkle Tree is a cryptographic tool that enables the
              consolidation of large amounts of data into a single hash. This
              single hash, called a Merkle Root, acts as a cryptographic seal
              that “summarizes” all the inputted data. Additionally, Merkle
              Trees give users the ability to verify specific contents that were
              included within a particular set of “sealed” data. We use these
              properties of Merkle Trees during our Proof of Reserves
              assessments to verify individual user accounts are included within
              the liabilities report inspected by the auditor.
            </p>
          </div>

          {/* Diagram */}
          <div className="bg-gray-50 dark:bg-gray-800 rounded-xl shadow p-8 mt-10 flex flex-col items-center">
            <img src={hash} className="w-[600px]" />
          </div>
        </div>
      </div>
      <div className="bg-white dark:bg-gray-900 text-gray-900 dark:text-white transition-colors duration-300 py-12 px-6 md:px-16">
        <div className="max-w-5xl mx-auto">
          <h1 className="text-3xl md:text-4xl font-bold mb-8">zk-SNARKs</h1>
          <div className="mb-10">
            <h2 className="text-xl md:text-2xl font-semibold mb-4">
              ▪ What have we built?
            </h2>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
              By using a zk-SNARK, a crypto exchange can prove that all Merkle
              tree leaf nodes’ balance sets (i.e., user account balances)
              contribute to the exchange’s claimed total user asset balance.
              Each user can easily access their leaf node as having been
              included in the process. For each user’s balance set (Merkle tree
              leaf node), our circuit ensures that:
            </p>
            <ul className="list-decimal list-inside mt-4 text-gray-700 dark:text-gray-300 space-y-1">
              <li>
                A user’s asset balances are included in the calculation of the
                sum of the total net user balances with an exchange.
              </li>
              <li>
                The total net balance of the user is greater than or equal to
                zero.
              </li>
              <li>
                The change of Merkle tree root is valid (i.e., not using
                falsified information) after updating a user’s information to
                the leaf node hash.
              </li>
            </ul>
          </div>
          <div>
            <h2 className="text-xl md:text-2xl font-semibold mb-4">
              ▪ What is a zk-SNARK?
            </h2>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
              A zk-SNARK (Zero-Knowledge Succinct Non-Interactive Argument of
              Knowledge) is a proof protocol that follows the zero-knowledge
              principles previously outlined. With a zk-SNARK, you can prove
              that you know the original hashed value (discussed further below)
              without revealing what that value is. You can also prove the
              validity of a transaction without revealing any information about
              the specific amounts, values, or addresses involved.
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ProofOfReserves;
